<!-- eslint-disable -->
<template lang="pug">
		user-form(
				:user="user"
				:type="type"
				:submit="create"
				:is-password-required="true"
				:not-enough-money-on-account="notEnoughMoneyError"
		)
				template(slot="title")
						template(v-if="type === 'student'") {{ $i18n.t('user.user_createForm_student') }}
						template(v-else-if="type === 'teacher'") {{ $i18n.t('user.user_createForm_teacher') }}
						template(v-else-if="type === 'admin'") {{ $i18n.t('user.user_createForm_admin') }}
				template(slot="button") {{ $i18n.t('user.user_createForm_create') }}
</template>

<script>
    /*eslint-disable*/
    import UserForm from './Form.vue'
    import UserApi from '../../api/user/user'
    import SchoolApi from '../../api/school'
    import {mapState} from 'vuex'
    export default {
        data() {
            return {
                user: {
                    lastName: '',
                    telegramVerified: false,
                    maxVerified: false,
                    firstName: '',
                    sex: 'male',
                    status: 'active',
                    locale: 'ru',
                    email: '',
                    username: '',
                    phone: '',
                    password: '',
                    passwordConfirmation: '',
                    school: '',
                    grades: [],
                    courses: '',
                    city: '',
                    address: '',
                    type: this.type,
                    parents: [
                        {
                            firstName: '',
                            lastName: '',
                            email: '',
                            phone: ''
                        },
                        {
                            firstName: '',
                            lastName: '',
                            email: '',
                            phone: ''
                        }
                    ]
                },
                notEnoughMoneyError: false,
            }
        },
        props: ['type'],
        watch: {
            authUser: {
                handler: function (user) {
                    if (user && user.school) {
                        SchoolApi.show(user.school.id).then((school) => {
                            this.user.school = school;
                        });
                    }
                },
                immediate: true
            }
        },
        mounted() {
            if (!this.$can('addItem', 'student')) {
                this.$router.push({ name: '403' });
            }
        },
        methods: {
            create(user) {
                return UserApi.create(user)
                .then((data) => {
                    this.$router.push({name: 'user:profile', params: {id: data.id, type: data.type}})
                })
                .catch(err => {
                    if (err.data.errors) {
                        for (let key in err.data.errors) {
                            let error = err.data.errors[key];
                            this.$toasted.error(error[0]);
                        }
                    } else if (err.status !== 402) {
                        this.$toasted.error(err.data.message);
                    } else if (err.data && err.data.message === 'could_not_create_student') {
                        this.notEnoughMoneyError = true;
                        window.localStorage.setItem('userModel', JSON.stringify(user));
                    }
                })
            }
        },
        computed: {
            ...mapState({
                authUser: state => state.auth.user,
            })
        },
        components: {
            UserForm
        }
    }

</script>
